import type { PollResultsResponseOptionsItemAllOf } from './pollResultsResponseOptionsItemAllOf';
import type { PollResultsResponseOptionsItemAllOfTwo } from './pollResultsResponseOptionsItemAllOfTwo';

export type PollResultsResponseOptionsItem = PollResultsResponseOptionsItemAllOf & PollResultsResponseOptionsItemAllOfTwo;
